(function($){

	$(document).ready(function(){

		$(document).on('click','.collapse-expand-content-module .btn-show-detailed-content',function(e){
			e.preventDefault();
			$(this).parent().toggleClass('open');
		});

	});

	$(window).scroll(function() {

  		$('.collapse-expand-content-module .media-container').each(function() {
    	
    		if (isScrolledIntoView(this)) {
      			$(this).addClass('active');
    		}
  		});
	});


	function isScrolledIntoView(elem) {
		var docViewTop = $(window).scrollTop();
		var docViewBottom = docViewTop + $(window).height();

		var elemTop = $(elem).offset().top;
		var elemBottom = elemTop + $(elem).height();

  		return ((elemTop <= docViewBottom) && (elemBottom >= docViewTop));
	}

	
})(jQuery);